import type { JSX } from 'react';

import { AudioPlayer } from 'components/audio-player';

import { addFormatter } from 'components/formatted-content/FormattedContent';

addFormatter('audio', {
	isEmbed: true,
	selector:
		/(https?:\/\/[^/\s]+\.[^/\s]+\/\S+\.(?:mp3|wav|ogg|m4a)(?:\?\S*)?)/gi,
	decorator: (guid: string, match: string): JSX.Element => {
		return <AudioPlayer key={guid} src={match} showTitle={true} />;
	},
});
